import { ScrollToTop } from 'sane-ui'
import { gsap } from 'gsap'

class CustomScrollToTop extends ScrollToTop {
  constructor ($el, args) {
    super($el, args)

    this.isVisible = false

    $(window).on(
      'scroll',
      () => {
        if (!this.isVisible) {
          if (window.pageYOffset > window.innerHeight) {
            gsap.to(this.$el, { duration: 0.3, autoAlpha: 1, ease: 'none' })
            this.isVisible = true
          }
        } else if (window.pageYOffset <= window.innerHeight) {
          gsap.to(this.$el, { duration: 0.3, autoAlpha: 0, ease: 'none' })
          this.isVisible = false
        }
      }
    )
  }
}

export default CustomScrollToTop



// WEBPACK FOOTER //
// ./scripts/components/CustomScrollToTop.js